import React from 'react';
import {
  FiEdit as EditIcon,
  FiNavigation as NavigationIcon,
} from 'react-icons/fi';
import { TrashIcon, DetailsIcon } from '../../Icons';
import { BaseActionsMenuButton, Action } from '../../Dropdowns';
import { ClientActionsRendererProps } from './types';
import { FlagsContext } from '../../../context';

export const ClientActionRenderer = ({
  data,
  handleClickRemove,
  handleClickEdit,
  handleClickInvite,
  handleClickViewDetails,
  entityName,
  onActionMenuClick,
}: ClientActionsRendererProps) => {
  const { EnableClientInviteEnhancement } = React.useContext(FlagsContext);
  const actions: Action[] = [
    {
      name: 'Edit info',
      icon: <EditIcon />,
      onClick: () => handleClickEdit(data),
    },
  ];
  if (data.status !== 'Active' && handleClickInvite) {
    const notInvitedActionName = EnableClientInviteEnhancement
      ? 'Invite client...'
      : 'Send invite';
    const invitedActionName = EnableClientInviteEnhancement
      ? 'Resend invite...'
      : 'Resend invite';
    actions.push({
      name:
        data.status === 'Invited' ? invitedActionName : notInvitedActionName,
      onClick: () => handleClickInvite(data),
      icon: <NavigationIcon />,
    });
  }
  if (handleClickViewDetails) {
    actions.unshift({
      name: 'View details',
      icon: <DetailsIcon />,
      onClick: () => handleClickViewDetails(data),
    });
  }
  actions.push({
    name: `Delete ${entityName || 'client'}`,
    onClick: () => handleClickRemove(data),
    icon: <TrashIcon />,
    isDelete: true,
  });

  return (
    <BaseActionsMenuButton
      onActionMenuClick={onActionMenuClick}
      actions={actions}
    />
  );
};
